import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Americký futbal",
    Baseball: "Bejzbal",
    Basketball: "Basketbal",
    Boxing: "Box",
    Chess: "Šach",
    Cricket: "Kriket",
    Darts: "Šípky",
    Entertainment: "Zábava",
    "E-Sports": "E-Sports",
    Football: "Futbal",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Galský futbal",
    "Generic Sport": "Generický šport",
    Golf: "Golf",
    "Greyhound Racing": "Psie dostihy",
    Handball: "Hádzaná",
    "Ice Hockey": "Ľadový Hokej",
    IndyCar: "IndyCars",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politika",
    "Rugby League": "Ragby League",
    "Rugby Union": "Ragby Union",
    Snooker: "Snooker",
    "Table Tennis": "Stolný tenis",
    Tennis: "Tenis",
    "Virtual Football": "Virtuálny futbal",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} zvíťazí",
    WinFirstRound: "{name} vyhrá prvé kolo",
    FirstTouchdown: "{name} skóruje ako prvý",
    FirstTry: "{name} pokúsi sa skórovať ako prvý",
    TotalGoals: "{name} získa celkom gólov",
    TotalRuns: "{name} získa celkom dobehov",
    TotalPoints: "{name} získa celkom bodov",
    TopBatsman: "{name} sa satne najlepším pálkarom",
    TopBowler: "{name} sa stane najlepším nadhadzovačom",
    FirstScore: "{name} strelí gól ako prvý"
  },
  PromoTexts: {
    Pick: "Tvoj výber",
    Bet: "Stávka",
    Pays: "Výplata"
  },
  DateTimeTexts: {
    Today: "Dnes",
    Tomorrow: "Zajtra",
    Live: "Naživo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Tvoj výber",
    Return: "Výplata",
    Stake: "Stávka",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "na zápas",
    H2H: "H2H",
    W: "V",
    D: "R",
    L: "P",
    T: "R",

    // soccer
    goals_scored: "Počet strelených gólov",
    shots: "Strely",
    shots_on_target: "Strely na bránu",
    ball_possession: "Držanie lopty",
    goals_conceded: "Inkasované góly",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
